module.exports = __webpack_public_path__ + "img/draw2_img2.47e3b7a4.png";